
export default function ExpiredCourse() {   
    return (
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">QHSE International E-learning Platform</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                          <p className='text-danger'> Your course is Expired please contact admin for further details admin@qhseinternational.com/+971 50 777 2173 </p>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
        </div>
    );
}
